import { useCallback } from "react";
import { usePolling } from "./use-polling";
import { inboxesApi } from "@/api/inboxes";
import { POLLING_INTERVAL_INBOXES } from "@/lib/constants";
import type { Inbox } from "@/types/inbox";

export function useInboxes(statusFilter?: string, channelFilter?: number) {
  const fetcher = useCallback(async () => {
    const params: Record<string, string> = {};
    if (statusFilter) params.status = statusFilter;
    if (channelFilter) params.id_channel = String(channelFilter);
    const res = await inboxesApi.list(params);
    return res.data || [];
  }, [statusFilter, channelFilter]);

  const { data, loading, error, refetch } = usePolling<Inbox[]>(
    fetcher,
    POLLING_INTERVAL_INBOXES,
  );

  return { inboxes: data || [], loading, error, refetch };
}
